/// <reference path="../../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var AuthData = /** @class */ (function () {
        function AuthData(authData) {
            if (!ap.Utilities.isNullOrUndefined(authData)) {
                this.updateAuthData(authData);
            }
        }
        Object.defineProperty(AuthData.prototype, "AccessToken", {
            get: function () { return this._accessToken; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthData.prototype, "ApplicationPermissions", {
            get: function () { return this._applicationPermissions; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthData.prototype, "ApplicationRoles", {
            get: function () { return this._applicationRoles; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthData.prototype, "DealerId", {
            get: function () { return this._dealerId; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthData.prototype, "Expires", {
            get: function () { return this._expires; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthData.prototype, "ExpiresInSeconds", {
            get: function () { return this._expiresInSeconds; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthData.prototype, "IsAuth", {
            get: function () { return this._isAuth; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthData.prototype, "IsManager", {
            get: function () { return this._isManager; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthData.prototype, "IsMp2", {
            get: function () { return this._isMp2; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthData.prototype, "LocalLoginDate", {
            get: function () { return this._localLoginDate; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthData.prototype, "LoginSystem", {
            get: function () { return this._loginSystem; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthData.prototype, "OrganizationUnitCacheKey", {
            get: function () { return this._organizationUnitCacheKey; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthData.prototype, "PreferredLanguageId", {
            get: function () { return this._preferredLanguageId; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthData.prototype, "RefreshToken", {
            get: function () { return this._refreshToken; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthData.prototype, "ShopId", {
            get: function () { return this._shopId; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthData.prototype, "UserCacheKey", {
            get: function () { return this._userCacheKey; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthData.prototype, "Version", {
            get: function () { return this._version; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthData.prototype, "FirstName", {
            get: function () { return this._firstName; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthData.prototype, "LastName", {
            get: function () { return this._lastName; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthData.prototype, "UserName", {
            get: function () { return this._userName; },
            enumerable: true,
            configurable: true
        });
        AuthData.prototype.getUTCTime = function (dateString) {
            var date = new Date(dateString);
            var utc = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
            return utc.getTime();
        };
        AuthData.prototype.hasApplicationClaim = function (claim, hasOnlyTheRequestedClaim) {
            return this._isAuth;
            /*if (!this._isValid) {
                return false;
            }

            var arrayCheckProperty = hasOnlyTheRequestedClaim ? 'every' : 'some';
            if (this._hasPermissions) {
                return this._applicationAccessClaims[arrayCheckProperty](x => x === claim);
            }

            // NOTE - This will return false if looking for "if and ONLY if"/hasOnlyTheRequestedClaim since every user it is required to have at LEAST 2 claims
            // product access and application access (i.e. access to MP2 - mp2User && "technician"/"admin"/"service advisor")
            return this.firstOrganization.applicationPermissions[arrayCheckProperty](x => x === claim);*/
        };
        AuthData.prototype.hasOrganizationProductClaim = function (claim, organizationCacheKey, includeParentalAccessCheck) {
            return this._isAuth && this._organizationUnitCacheKey === organizationCacheKey;
            /*if (!this._isValid) {
                return false;
            }

            var hasAccess = !ap.Utilities.isNullOrEmptyCollection((this._productAccessClaims[claim] || []).filter(x => x === organizationCacheKey));
            if (hasAccess || !ap.Utilities.isTrueValue(includeParentalAccessCheck)) {
                return hasAccess;
            }

            return this.hasOrganizationProductClaim(claim, this.firstOrganization.organizationUnitCacheKey);
            */
        };
        AuthData.prototype.isExpired = function (bufferInMinutes) {
            return this.isTokenExpired('_longTermExpirationUtcTime', bufferInMinutes);
        };
        AuthData.prototype.isStale = function (bufferInMinutes) {
            return this.isTokenExpired('_shortTermExpirationUtcTime', bufferInMinutes);
        };
        AuthData.prototype.isTokenExpired = function (field, bufferInMinutes) {
            return false; // todo
            /*
            if (!this._isValid) {
                return true;
            }

            var now: number = this.getUTCTime(new Date().toString());
            var expiration: number = this[field];
            var expirationMinusNow = expiration - now;
            var buffered = (ap.Utilities.isNullOrUndefined(bufferInMinutes) ? this._timeOutBufferSeconds : bufferInMinutes * 60) * 1000;
            var expired = expirationMinusNow < buffered;

            return expired;
            */
        };
        AuthData.prototype.toIAuthDataForCookieStorage = function () {
            return {
                AccessToken: this._accessToken,
                ApplicationPermissions: this._applicationPermissions,
                ApplicationRoles: this._applicationRoles,
                DealerId: this._dealerId,
                Expires: this._expires,
                ExpiresInSeconds: this._expiresInSeconds,
                IsAuth: this._isAuth,
                IsManager: this._isManager,
                IsMp2: this._isMp2,
                LocalLoginDate: this._localLoginDate,
                LoginSystem: this._loginSystem,
                OrganizationUnitCacheKey: this._organizationUnitCacheKey,
                PreferredLanguageId: this._preferredLanguageId,
                RefreshToken: this._refreshToken,
                ShopId: this._shopId,
                UserCacheKey: this._userCacheKey,
                Version: this._version,
                FirstName: this._firstName,
                LastName: this._lastName,
                UserName: this._userName
            };
        };
        AuthData.prototype.selectedOrgExists = function (authData) {
            return (!ap.Utilities.isNullOrUndefined(authData['activeOrg']));
        };
        /**
         * This will either update the AuthData if present OR will clear all properties if null is passed as parameter
         * @param authData - An IAuthData object from the SSO service/cookie storage
         */
        AuthData.prototype.updateAuthData = function (authData) {
            this._accessToken = '';
            this._applicationPermissions = [];
            this._applicationRoles = [];
            this._expires = '';
            this._expiresInSeconds = 0;
            this._isAuth = false;
            this._isManager = false;
            this._isMp2 = false;
            this._localLoginDate = '';
            this._loginSystem = '';
            this._organizationUnitCacheKey = '';
            this._preferredLanguageId = 0;
            this._refreshToken = '';
            this._shopId = 0;
            this._userCacheKey = '';
            this._version = 0;
            this._firstName = '';
            this._lastName = '';
            this._userName = '';
            if (ap.Utilities.isNullOrUndefined(authData)) {
                return;
            }
            if (authData.hasOwnProperty('Expires') || authData.hasOwnProperty('UserCacheKey')) { // welcomepoint cookie
                this._accessToken = authData.AccessToken;
                this._applicationPermissions = [];
                this._applicationRoles = [];
                this._expires = authData.Expires;
                this._expiresInSeconds = authData.ExpiresInSeconds;
                this._isAuth = authData.IsAuth;
                this._isManager = authData.IsManager;
                this._isMp2 = authData.IsMp2;
                this._localLoginDate = authData.LocalLoginDate;
                this._loginSystem = authData.LoginSystem;
                this._organizationUnitCacheKey = authData.OrganizationUnitCacheKey;
                this._preferredLanguageId = authData.PreferredLanguageId;
                this._refreshToken = authData.RefreshToken;
                this._shopId = authData.ShopId;
                this._userCacheKey = authData.UserCacheKey;
                this._version = authData.Version;
                this._firstName = authData.FirstName;
                this._lastName = authData.LastName;
                this._userName = authData.UserName;
            }
            else if (authData['.expires']) { //sso cookie
                this._accessToken = authData['access_token'];
                this._applicationPermissions = (this.selectedOrgExists(authData)) ?
                    authData['activeOrg'].applicationPermissions : authData['organization_units'][0].applicationPermissions;
                this._applicationRoles = (this.selectedOrgExists(authData)) ? authData['activeOrg'].applicationRoles : authData['organization_units'][0].applicationRoles;
                this._expires = authData['.expires'];
                this._expiresInSeconds = authData['expires_in'];
                this._isAuth = true;
                this._isManager = (this.selectedOrgExists(authData)) ? this.isAdmin(authData['activeOrg']) : this.isAdmin(authData['organization_units'][0]);
                this._isMp2 = true;
                this._localLoginDate = Date();
                this._loginSystem = 'SSO';
                this._organizationUnitCacheKey = (this.selectedOrgExists(authData)) ?
                    authData['activeOrg'].organizationUnitCacheKey : authData['organization_units'][0].organizationUnitCacheKey;
                this._preferredLanguageId = 1;
                this._refreshToken = authData['refresh_token'];
                this._shopId = 1;
                this._userCacheKey = authData['user_cache_key'];
                this._version = 1;
                this._firstName = authData['first_name'];
                this._lastName = authData['last_name'];
                this._userName = authData['username'];
            }
        };
        AuthData.prototype.isAdmin = function (org) {
            if (org && org.applicationRoles) {
                return org.applicationRoles.indexOf(6) >= 0; // 6 = admin in mp2
            }
        };
        AuthData.prototype.toJSON = function (space) {
            return JSON.stringify(this.toIAuthDataForCookieStorage(), null, space);
        };
        return AuthData;
    }());
    app.AuthData = AuthData;
})(app || (app = {}));
